const config = {
  googleMapsApiKey: "AIzaSyALtsO20Cp0ABCTHF76drBZLYsXDmypR58",
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL ?? "",
};

export default config;
